import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import authReducer from './authReducer';
import errorsReducer from './errorsReducer';
import settingsReducer from './settingsReducer';
import mainMarketsReducer from './mainMarketsReducer';
import marketDescriptionsReducer from './marketDescriptionsReducer';
import sportEventsReducer from './sportEventsReducer';
import messagesReducer from './messagesReducer';
import sportTypesReducer from './sportTypesReducer';
import allMarketsReducer from './allMarketsReducer';
import betSlipReducer from './betSlipReducer';
import eventDetailReducer from './eventDetailReducer';
import ticketsReducer from './ticketsReducer';
import terminalsReducer from './terminals';
import timerReducer from './timerReducer';
import eventResultsReducer from './eventResultsReducer';
import seasonsReducer from './seasonsReducer';
import socketReducer from './socketReducer';
import reportsReducer from './reportsReducer';
import modals from './modals';
import increaseReports from './increase-reports';
import feed from './feed';
import favoritesReducer from './favoritesReducer';
import global from './global';
import vouchersReducer from './vouchersReducer';
import translationsReducer from './translationsReducer';
import outrights from './outrightsReducer';

const betSlipPersistConfig = {
    key: 'betslip',
    storage,
    blacklist: [
        'placedBetErrors',
        'isTicketSubmitting',
        'isFetchingEvents',
        'validations',
        'selectedCombinations',
        'stakeLimits',
        'retryCounter',
        'errorTimeout',
    ],
    stateReconciler: autoMergeLevel2,
};

const descriptionConfig = {
    key: 'descriptions',
    storage,
};

const settingsPersistConfig = {
    key: 'settings',
    storage: storageSession,
    whitelist: ['translationMode'],
    stateReconciler: autoMergeLevel2,
};

const translationsPersistConfig = {
    key: 'translations',
    storage,
    whitelist: ['list'],
    stateReconciler: autoMergeLevel2,
};

const appReducer = combineReducers({
    auth: authReducer,
    error: errorsReducer,
    settings: persistReducer(settingsPersistConfig, settingsReducer),
    global,
    mainMarkets: mainMarketsReducer,
    messages: messagesReducer,
    sportEvents: sportEventsReducer,
    outrights,
    sportTypes: sportTypesReducer,
    allMarkets: allMarketsReducer,
    eventDetails: eventDetailReducer,
    tickets: ticketsReducer,
    terminals: terminalsReducer,
    vouchers: vouchersReducer,
    reports: reportsReducer,
    increaseReports,
    timer: timerReducer,
    results: eventResultsReducer,
    seasons: seasonsReducer,
    socket: socketReducer,
    betSlip: persistReducer(betSlipPersistConfig, betSlipReducer),
    descriptions: persistReducer(descriptionConfig, marketDescriptionsReducer),
    modals,
    feed,
    favorites: favoritesReducer,
    translations: persistReducer(translationsPersistConfig, translationsReducer),
});

export default function rootReducer(state, action) {
    if (action.type === 'LOGOUT_USER_SUCCESS') {
        state = undefined;
    }

    return appReducer(state, action);
}
